module.exports = __webpack_public_path__ + "img/card4.2a8ef7fe.jpg";